<template>
  <div class="order" v-if="hasProductsInBasket">

    <h1 v-if="!completed">
      Din beställning
    </h1>

    <div class="inner">
      <ul>
        <li class="item" v-for="item in basket" :key="item.name">
          <MenuItem :item="item" :completed="completed" />
        </li>
      </ul>

      <div class="order-total">
        Totalt: {{ basketTotal }} kr
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import MenuItem from 'components/order/menu-item';

  export default {
    name: 'OrderBasket',
    components: { MenuItem },
    props: {
      completed: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      ...mapGetters('order', ['basket', 'hasProductsInBasket', 'basketTotal'])
    }
  };
</script>

<style lang="stylus" scoped>
  @require '~global/typo'
  @require '~global/helpers'

  .order
    @extend .order-box

  h1
    @extend .t-orderHeader

  .menu-item
    margin-bottom: .5rem

  .item
    margin-bottom: 1.5rem

  .order-total
    text-align: left
    position: relative
    padding-top: 1rem
    margin-top: 1.4rem
    text-transform: uppercase

    &:before
      content: ""
      position: absolute
      top: 0
      left: -1.6rem
      right: -1.6rem
      height: 1px
      background-image: repeating-linear-gradient(to right, black 0 6px, transparent 6px 9px)

  .order .inner
    padding: 2rem 2rem 1rem 2rem

  .menu-item:last-of-type
    margin-bottom: 0
</style>
